import { inCommands } from '../../../concepts/commands/CommandRegistry';
import { Communicator } from '../../../concepts/objects';
import { Connector, Package, PackageHost } from '../../Container';
import { toast } from './ToastCommands';
import { ToastHub } from './ToastHub';
import { ToastLibrary } from './ToastLibrary';
import { inToastWhenParticipantJoins } from './ToastWhenParticipantJoins';

const inStandardToastBehaviors: Connector = r => {
    const comms = r.call(Communicator);
    // const clients = r.call(ClientManager);
    const hub = r.call(ToastHub);
    return [
        // Probably need to handle this inside ParticipantManager
        // clients.on('join', (client) => {
        //     hub.invoke('ptpt:join', hub.createSenderContextData(client.userId));
        // }),
        comms.recv('boardName', (client, _data) => {
            hub.invoke('ptpt:title', hub.createSenderContextData(client.userId));
        }),
    ];
};

export class ToastPackage implements Package {

    public install = (host: PackageHost) => host
        .register(ToastLibrary, 'singleton')
        .register(ToastHub, 'singleton')
        // .register(ToastHub, 'singleton')
        .plug(inStandardToastBehaviors)
        .plug(inToastWhenParticipantJoins)
        .plug(inCommands(toast))
        .start(ToastHub)
        ;
}
